/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UserRouteImport } from './routes/user'
import { Route as RegionRouteImport } from './routes/region'
import { Route as PositionCodeRouteImport } from './routes/positionCode'
import { Route as OrderRouteImport } from './routes/order'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CourseRouteImport } from './routes/course'
import { Route as ClassRouteImport } from './routes/class'
import { Route as CarouselRouteImport } from './routes/carousel'
import { Route as BlacklistRouteImport } from './routes/blacklist'
import { Route as BatchRouteImport } from './routes/batch'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AgreementTemplateRouteImport } from './routes/agreementTemplate'
import { Route as AdminRegisterRouteImport } from './routes/adminRegister'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DemoTanstackQueryRouteImport } from './routes/demo.tanstack-query'

const UserRoute = UserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const RegionRoute = RegionRouteImport.update({
  id: '/region',
  path: '/region',
  getParentRoute: () => rootRouteImport,
} as any)
const PositionCodeRoute = PositionCodeRouteImport.update({
  id: '/positionCode',
  path: '/positionCode',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderRoute = OrderRouteImport.update({
  id: '/order',
  path: '/order',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CourseRoute = CourseRouteImport.update({
  id: '/course',
  path: '/course',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassRoute = ClassRouteImport.update({
  id: '/class',
  path: '/class',
  getParentRoute: () => rootRouteImport,
} as any)
const CarouselRoute = CarouselRouteImport.update({
  id: '/carousel',
  path: '/carousel',
  getParentRoute: () => rootRouteImport,
} as any)
const BlacklistRoute = BlacklistRouteImport.update({
  id: '/blacklist',
  path: '/blacklist',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchRoute = BatchRouteImport.update({
  id: '/batch',
  path: '/batch',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AgreementTemplateRoute = AgreementTemplateRouteImport.update({
  id: '/agreementTemplate',
  path: '/agreementTemplate',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRegisterRoute = AdminRegisterRouteImport.update({
  id: '/adminRegister',
  path: '/adminRegister',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTanstackQueryRoute = DemoTanstackQueryRouteImport.update({
  id: '/demo/tanstack-query',
  path: '/demo/tanstack-query',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/adminRegister': typeof AdminRegisterRoute
  '/agreementTemplate': typeof AgreementTemplateRoute
  '/analytics': typeof AnalyticsRoute
  '/batch': typeof BatchRoute
  '/blacklist': typeof BlacklistRoute
  '/carousel': typeof CarouselRoute
  '/class': typeof ClassRoute
  '/course': typeof CourseRoute
  '/login': typeof LoginRoute
  '/order': typeof OrderRoute
  '/positionCode': typeof PositionCodeRoute
  '/region': typeof RegionRoute
  '/user': typeof UserRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/adminRegister': typeof AdminRegisterRoute
  '/agreementTemplate': typeof AgreementTemplateRoute
  '/analytics': typeof AnalyticsRoute
  '/batch': typeof BatchRoute
  '/blacklist': typeof BlacklistRoute
  '/carousel': typeof CarouselRoute
  '/class': typeof ClassRoute
  '/course': typeof CourseRoute
  '/login': typeof LoginRoute
  '/order': typeof OrderRoute
  '/positionCode': typeof PositionCodeRoute
  '/region': typeof RegionRoute
  '/user': typeof UserRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/adminRegister': typeof AdminRegisterRoute
  '/agreementTemplate': typeof AgreementTemplateRoute
  '/analytics': typeof AnalyticsRoute
  '/batch': typeof BatchRoute
  '/blacklist': typeof BlacklistRoute
  '/carousel': typeof CarouselRoute
  '/class': typeof ClassRoute
  '/course': typeof CourseRoute
  '/login': typeof LoginRoute
  '/order': typeof OrderRoute
  '/positionCode': typeof PositionCodeRoute
  '/region': typeof RegionRoute
  '/user': typeof UserRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/adminRegister'
    | '/agreementTemplate'
    | '/analytics'
    | '/batch'
    | '/blacklist'
    | '/carousel'
    | '/class'
    | '/course'
    | '/login'
    | '/order'
    | '/positionCode'
    | '/region'
    | '/user'
    | '/demo/tanstack-query'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/adminRegister'
    | '/agreementTemplate'
    | '/analytics'
    | '/batch'
    | '/blacklist'
    | '/carousel'
    | '/class'
    | '/course'
    | '/login'
    | '/order'
    | '/positionCode'
    | '/region'
    | '/user'
    | '/demo/tanstack-query'
  id:
    | '__root__'
    | '/'
    | '/adminRegister'
    | '/agreementTemplate'
    | '/analytics'
    | '/batch'
    | '/blacklist'
    | '/carousel'
    | '/class'
    | '/course'
    | '/login'
    | '/order'
    | '/positionCode'
    | '/region'
    | '/user'
    | '/demo/tanstack-query'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRegisterRoute: typeof AdminRegisterRoute
  AgreementTemplateRoute: typeof AgreementTemplateRoute
  AnalyticsRoute: typeof AnalyticsRoute
  BatchRoute: typeof BatchRoute
  BlacklistRoute: typeof BlacklistRoute
  CarouselRoute: typeof CarouselRoute
  ClassRoute: typeof ClassRoute
  CourseRoute: typeof CourseRoute
  LoginRoute: typeof LoginRoute
  OrderRoute: typeof OrderRoute
  PositionCodeRoute: typeof PositionCodeRoute
  RegionRoute: typeof RegionRoute
  UserRoute: typeof UserRoute
  DemoTanstackQueryRoute: typeof DemoTanstackQueryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/region': {
      id: '/region'
      path: '/region'
      fullPath: '/region'
      preLoaderRoute: typeof RegionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/positionCode': {
      id: '/positionCode'
      path: '/positionCode'
      fullPath: '/positionCode'
      preLoaderRoute: typeof PositionCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order': {
      id: '/order'
      path: '/order'
      fullPath: '/order'
      preLoaderRoute: typeof OrderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course': {
      id: '/course'
      path: '/course'
      fullPath: '/course'
      preLoaderRoute: typeof CourseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/class': {
      id: '/class'
      path: '/class'
      fullPath: '/class'
      preLoaderRoute: typeof ClassRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carousel': {
      id: '/carousel'
      path: '/carousel'
      fullPath: '/carousel'
      preLoaderRoute: typeof CarouselRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blacklist': {
      id: '/blacklist'
      path: '/blacklist'
      fullPath: '/blacklist'
      preLoaderRoute: typeof BlacklistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batch': {
      id: '/batch'
      path: '/batch'
      fullPath: '/batch'
      preLoaderRoute: typeof BatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agreementTemplate': {
      id: '/agreementTemplate'
      path: '/agreementTemplate'
      fullPath: '/agreementTemplate'
      preLoaderRoute: typeof AgreementTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/adminRegister': {
      id: '/adminRegister'
      path: '/adminRegister'
      fullPath: '/adminRegister'
      preLoaderRoute: typeof AdminRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tanstack-query': {
      id: '/demo/tanstack-query'
      path: '/demo/tanstack-query'
      fullPath: '/demo/tanstack-query'
      preLoaderRoute: typeof DemoTanstackQueryRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRegisterRoute: AdminRegisterRoute,
  AgreementTemplateRoute: AgreementTemplateRoute,
  AnalyticsRoute: AnalyticsRoute,
  BatchRoute: BatchRoute,
  BlacklistRoute: BlacklistRoute,
  CarouselRoute: CarouselRoute,
  ClassRoute: ClassRoute,
  CourseRoute: CourseRoute,
  LoginRoute: LoginRoute,
  OrderRoute: OrderRoute,
  PositionCodeRoute: PositionCodeRoute,
  RegionRoute: RegionRoute,
  UserRoute: UserRoute,
  DemoTanstackQueryRoute: DemoTanstackQueryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
